module.exports = __webpack_public_path__ + "img/Button_Autospin.a32b4709.png";